import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { UserBox } from '@/components/modules/Image/UserBox';
import { Head } from '@/components/ui/Typography/Heading/Head';
import { professionalUnitPath } from '@/utils/router/links';
/**
 * クライアント：ファイル共有一括送信フォーム（入力確認）
 * @param props
 * @constructor
 */
export const RfpClientOneFileAllFormConfirmUserBoxList = (props) => {
    const { className, idList, users: propUsers } = props;
    // IDに一致するユーザーに絞り込み
    const users = useMemo(() => (propUsers || []).filter((user) => idList.includes(parseInt(user.id.toString(), 10))), [idList, propUsers]);
    return (_jsxs("div", Object.assign({ className: clsx(className) }, { children: [_jsx(Head, Object.assign({ className: 'mb-8', color: 'base', size: 'xs' }, { children: "\u4E0B\u8A18\u306E\u30C1\u30FC\u30E0\u306B\u8CC7\u6599\u3092\u5171\u6709\u3057\u307E\u3059" })), _jsx("div", Object.assign({ className: clsx('w-full max-h-[160px]', 'p-12', 'border border-solid border-gray-400', 'overflow-auto') }, { children: users.map((user) => (_jsx(UserBox, { className: clsx('py-12 first:pt-0 last:pb-0', 'border-0 border-b border-b-gray-400 border-solid last:border-b-0'), extraTexts: [
                        {
                            link: user.urlCode ? professionalUnitPath(user.urlCode) : '',
                            text: user.companyName,
                        },
                    ], firstName: user.firstName, id: user.professionalId, imageSrc: user.imageSrc, isShowDetailPage: user.isShowDetailPage, lastName: user.lastName, professionalType: user.professionalType }, user.id))) }))] })));
};
